import React from 'react';

import { useRecoilValue } from 'recoil';

import { hasModule } from 'lib/helpers/utility';

import { modulesState } from 'components/state';

import { getInvoiceDetails } from '../lib/internal/configs';

import NewInvoiceDetailsTable from './NewInvoiceDetailsTable';

const NewInvoice = ({ invoice, children, exportId, isView = false, isAEOB, isDetailed }) => {
  const practiceModules = useRecoilValue(modulesState);

  const claims = hasModule(practiceModules, 'billing.claims');

  const patientInvoiceDetails = getInvoiceDetails(invoice, claims);

  return (
    <div className="w-full !p-4">
      <div className="flex gap-3"></div>
      <div>
        <NewInvoiceDetailsTable
          exportId={exportId}
          invoices={patientInvoiceDetails}
          isView={isView}
          isAEOB={isAEOB}
          isDetailed={isDetailed}
        />
      </div>
      {children}
    </div>
  );
};

export default NewInvoice;
